import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/buttonLoader.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/loader.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/magic-wand2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/messagesv2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/question-mark-2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/Waves.svg");
;
import(/* webpackMode: "eager" */ "/app/public/img/bot-wizard/check.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Handler"] */ "/app/src/app/[locale]/(pages)/(main)/chats/[recipientId]/Handler/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReportActionsProvider"] */ "/app/src/context/report/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BotActions"] */ "/app/src/entities/bot/ui/BotActions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BotHeader"] */ "/app/src/entities/bot/ui/BotHeader/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/entities/bot/ui/BotProfileCard/styles.ts?./styles.linaria.module.css?css=H4sIAAAAAAAAA42OQY7CMAxF95yCJSwckWoWkCw5BmKR2m4mIk0qJ63aQdx9VOgB2Nj+kt+zVdsuSzfM+zL5/a1UyQ++Pz/d4CjCqV5zzGJfOyWEWi7uSaEM0S2mizzbtQAFYawhJ4M5jn2ygyMKyZtGuLdtFmIBcRTGYiYnB9gCxKNtHT685DER4HppW3jP4IUX0CcoOQY6Wu8G06ifVfraqTL5+TzhN/+s4EmdN7DTfMn4p78hXQw+QajcF1OqcMXft02r5mP7B6Xj08tDAQAA");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedNumber"] */ "/app/src/shared/ui/atoms/AnimatedNumber/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/atoms/Dropdown/Dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/atoms/Dropdown/DropdownElement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedNumberWithContent"] */ "/app/src/shared/ui/molecules/AnimatedNumberWithContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AutosizeTextAreaField"] */ "/app/src/shared/ui/molecules/AutosizeTextAreaField/AutosizeTextAreaField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PasswordField"] */ "/app/src/shared/ui/molecules/PasswordField/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextareaField"] */ "/app/src/shared/ui/molecules/TextareaField/index.tsx");
